module.exports = {"140121100":"清源镇","140121101":"徐沟镇","140121102":"东于镇","140121103":"孟封镇","140121200":"马峪乡","140121201":"柳杜乡","140121202":"西谷乡","140121203":"王答乡","140121204":"集义乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140121.json
// module id = 265
// module chunks = 0